const EN = {
    title: 'Dashboards'
};

export default EN;
